import { Route } from '../../contracts';
import personalDetailsRouteInfo from '../../tabs/PersonalDetails/routes/routeInfo';
import financingTermsRouteInfo from '../../tabs/FinancingTerms/routes/routeInfo';
import notificationSettingsRouteInfo from '../../tabs/NotificationSettings/routes/routeInfo';
import privacySettingsRouteInfo from '../../tabs/PrivacySettings/routes/routeInfo';
import referralsRouteInfo from '../../tabs/Referrals/routes/routeInfo';

export const routes: Record<string, Route> = {
  ...personalDetailsRouteInfo,
  ...financingTermsRouteInfo,
  ...notificationSettingsRouteInfo,
  ...privacySettingsRouteInfo,
  ...referralsRouteInfo
};

export default routes;
